import BigNumber from 'bignumber.js'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Button, Modal, Text, TextProps } from '../../../uikit-foodcourt'
import ModalActions from 'components/ModalActions'
import ModalInput from 'components/ModalInput'
import { useTranslation } from 'contexts/Localization'
import { getFullDisplayBalance } from 'utils/formatBalance'
import { BIG_TEN } from 'utils/bigNumber'
import { DEFAULT_TOKEN_DECIMAL } from 'config'

interface WithdrawModalProps {
	max: BigNumber
	onConfirm: (amount: string) => void
	onDismiss?: () => void
	tokenName?: string
	isWithdrawFee100?: boolean
	decimals?: number
}

const WithdrawModal: React.FC<WithdrawModalProps> = ({
	onConfirm,
	onDismiss,
	max,
	tokenName = '',
	isWithdrawFee100,
	decimals,
}) => {
	const [val, setVal] = useState('')
	const [pendingTx, setPendingTx] = useState(false)
	const { t } = useTranslation()
	const fullBalance = useMemo(() => {
		return getFullDisplayBalance(max, decimals)
	}, [max])

	const valNumber = new BigNumber(val)
	const fullBalanceNumber = new BigNumber(fullBalance)

	const handleChange = useCallback(
		(e: React.FormEvent<HTMLInputElement>) => {
			if (e.currentTarget.validity.valid) {
				setVal(e.currentTarget.value.replace(/,/g, '.'))
			}
		},
		[setVal],
	)

	const handleSelectMax = useCallback(() => {
		setVal(fullBalance)
	}, [fullBalance, setVal])

	useEffect(() => {
		if (isWithdrawFee100) {
			setVal(fullBalance)
		}
	}, [isWithdrawFee100, fullBalance])

	return (
		<Modal title={t('Unstake LP tokens')} onDismiss={onDismiss}>
			{!isWithdrawFee100 && (
				<ModalInput
					onSelectMax={handleSelectMax}
					onChange={handleChange}
					value={val}
					max={fullBalance}
					symbol={tokenName}
					inputTitle={t('Unstake')}
				/>
			)}

			{isWithdrawFee100 && (
				<Text style={{ color: 'hsl(9, 95%, 65%)', maxWidth: 'fit-content' }}>
					WARNING: This is 100% withdrawal fee pool, You will lose all your COUPON reward if you
					unstake your {tokenName}.
				</Text>
			)}

			<ModalActions>
				<Button variant="secondary" onClick={onDismiss} width="90%" disabled={pendingTx}>
					{t('Cancel')}
				</Button>
				<Button
					disabled={
						pendingTx || !valNumber.isFinite() || valNumber.eq(0) || valNumber.gt(fullBalanceNumber)
					}
					onClick={async () => {
						if (
							isWithdrawFee100 &&
							!window.confirm(
								`WARNING: This is 100% withdrawal fee pool, You will lose all your COUPON reward if you unstake your ${tokenName}`,
							)
						)
							return

						const adjustedVal = new BigNumber(val).times(BIG_TEN.pow(decimals)).div(DEFAULT_TOKEN_DECIMAL);

						setPendingTx(true)
						await onConfirm(adjustedVal.toString())
						setPendingTx(false)
						onDismiss()
					}}
					width="120%"
					style={{ marginLeft: '-20%' }}
				>
					{pendingTx ? t('Pending Confirmation') : isWithdrawFee100 ? 'Unstake All' : t('Confirm')}
				</Button>
			</ModalActions>
		</Modal>
	)
}

export default WithdrawModal
